import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Rails from "@rails/ujs"
import Modal from "bootstrap/js/dist/modal"

export default class extends Controller {
  submit(event) {
    event.preventDefault()
    const form = event.target

    $.ajax({
      method: form.getAttribute("method") || "post",
      url: form.getAttribute("action"),
      dataType: "json",
      data: new FormData(form),
      processData: false,
      contentType: false,
      complete: () => {
        // This form is submitted via a hand-rolled $.ajax call rather than
        // Rails-UJS's own remote-form flow, so UJS's automatic re-enable (which
        // normally fires on ajax:complete) never triggers for data-disable-with
        // buttons here. Re-enable manually so the button isn't stuck disabled
        // next time this same modal is reopened.
        Rails.enableElement(form)
      },
      success: (response) => {
        // Some modals (e.g. a group's own edit modal) are nested inside the
        // very partial their own success response re-renders. Swapping the
        // HTML while Modal#hide()'s CSS transition is still in flight replaces
        // this modal's DOM node out from under it, so the backdrop and body
        // scroll-lock never clean up and the modal visually never closes.
        // Waiting for hidden.bs.modal ensures the transition has fully
        // finished (class/backdrop/body cleanup all done) before we swap.
        if (response.success) {
          const modalEl = this.element
          // Let listeners outside this modal (e.g. a page that opened this
          // shared modal to create a record inline) react to the response
          // before we tear down the form/partials below.
          modalEl.dispatchEvent(new CustomEvent('modal-form:success', { detail: response, bubbles: true }))
          // Bootstrap dispatches its lifecycle events as native events; bind
          // with addEventListener rather than jQuery's .one(), which doesn't
          // reliably observe them.
          modalEl.addEventListener('hidden.bs.modal', () => {
            this.renderPartials(response.partials)
          }, { once: true })
          Modal.getOrCreateInstance(modalEl).hide()
          form.reset()
        } else {
          this.renderPartials(response.partials)
        }
      },
      error: (xhr, status, error) => {
        console.info(error)
      }
    })
  }

  renderPartials(partials) {
    Object.entries(partials || {}).forEach(([key, html]) => {
      $(`.partial[data-id="${key}"]`).html(html)
    })
    // The listener is bound to 'body' specifically (see mixins/cocoon.js) -
    // triggering on document wouldn't reach it, since trigger() bubbles up
    // the tree, not down.
    $('body').trigger('cocoon:after-insert')
  }
}
